module.exports = __webpack_public_path__ + "img/okay.f21b4b13.svg";